export class ApiText {
    shortLabel: string;
    fullLabel?: string;
    detail?: string;
    summary?: string;

    constructor(shortLabel: string, fullLabel?: string, summary?: string, detail?: string) {
        this.shortLabel = shortLabel.trim();
        this.fullLabel = fullLabel ? fullLabel.trim() : shortLabel.trim();
        this.detail = detail ? detail.trim() : null;
        this.summary = summary ? summary.trim() : null;
    }
}
